import { render, staticRenderFns } from "./PresupuestoEstimacionIngresos.vue?vue&type=template&id=552661fc&scoped=true"
import script from "./PresupuestoEstimacionIngresos.vue?vue&type=script&lang=js"
export * from "./PresupuestoEstimacionIngresos.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoEstimacionIngresos.vue?vue&type=style&index=0&id=552661fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552661fc",
  null
  
)

export default component.exports